import React from 'react';
import {
  ExtensionSlot,
} from 'piral-core';

// Helper function to render multiple extension slots in grid cells
const renderSlots = (baseName, props, maxSlots = 12) => {
  const slots = [];

  // Render numbered slots (e.g., "grid-1", "grid-2", etc.)
  for (let i = 1; i <= maxSlots; i++) {
    slots.push(
      <div key={`${baseName}-${i}`} style={{
        padding: '15px',
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        overflowY: 'auto'
      }}>
        <ExtensionSlot name={`${baseName}-${i}`} params={props} />
      </div>
    );
  }

  return slots;
};

/**
 * Grid Layout Component
 * 
 * This layout provides a responsive grid with automatically placed items.
 * Grid items will wrap to new rows as needed.
 * 
 * AVAILABLE EXTENSION SLOTS:
 * - "grid-1", "grid-2", "grid-3", ... up to "grid-12"
 * 
 * GRID CONFIGURATION:
 * - Minimum column width: 300px
 * - Auto-fit: Columns automatically adjust based on available space
 * - Gap: 20px between items
 * 
 * USE CASE:
 * - Dashboard widgets
 * - Card-based UIs
 * - Portfolio/gallery layouts
 * - Responsive content grids
 * 
 */
export default {
  Layout: (props) => {
    const { pageKey, ...otherProps } = props;
    const prefix = `${pageKey || ''}-`;
    
    return (
      <div style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '20px',
        padding: '20px',
        height: '100vh',
        width: '100%',
        overflowY: 'auto'
      }}>
        {renderSlots(`${prefix}grid`, otherProps)}
      </div>
    );
  },
}
